export const LOG_CLIENT_NAME: string = 'web-client';
export const LOG_SERVER_NAME: string = 'web-server';

export const LOG_MEMBER_PROCESS_NAME = 'membership-enrollment';
export const LOG_LICENSES_PROCESS_NAME = 'licenses';
